export const NAME_PATTERN = /^[a-zA-Z]+((['.-]|[a-zA-Z]|\s)?[a-zA-Z]*)*$/;
export const PHONE_NUMBER_INPUT_PATTERN = /^[+\d\s]*$/;
export const EMAIL_PATTERN = /^[a-z][\w.-]*[a-z0-9]@[\w]{2,7}(-\w{2,5})?(\.[a-z]{2,5}){0,2}$/i;
export const MOBILE_PHONE_NUMBER_PATTERN = /^(07)(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/;
export const ADDITIONAL_PHONE_NUMBER_PATTERN = /^(0)([127])(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/;

export const ANALYTICS_APPT_CONTACT_CANCEL = 'amend appt:Add new site contact cancel';
export const ANALYTICS_APPT_CONTACT_SAVE = 'amend appt:Add new site contact save';
